import React, {useEffect} from 'react'
import {Route, BrowserRouter as Router, Routes} from 'react-router-dom'
import MockupGeneratorContainer from './components/step2/MockupGeneratorContainer'
import MockupGeneratorRedirect from './components/redirect'
import WelcomePageContainer from './components/welcome'
import {addHotjarScript} from './helpers/addHotjarScript'
import ShopifyMappingContainer from './components/shopify-mapping/ShopifyMappingContainer'
import CreateCustomShape, {NavigateWrapper} from './components/create-custom-shape'
import MockupTestPage from './components/mockup-test/MockupTestPage'
import PlaygroundPage from './components/playground/PlaygroundPage'

function App() {
    useEffect(() => {
        const hotjar = addHotjarScript()
        document.head.appendChild(hotjar)

        return () => {
            document.head.removeChild(hotjar)
        }
    }, [])
    return (
        <div className="App">
            <Router>
                <Routes>
                    <Route path="/" element={<MockupGeneratorRedirect />} />
                    <Route path="/ping" element={<WelcomePageContainer />} />
                    <Route path="/mapping-variants/:productId" element={<ShopifyMappingContainer />} />
                    <Route path="/:productId" element={<MockupGeneratorContainer />} />
                    <Route path="/create-custom-shape" element={<NavigateWrapper />}>
                        <Route path="" element={<CreateCustomShape />} />
                    </Route>
                    <Route path="/mockup-test" element={<MockupTestPage />} />
                    <Route path="/playground" element={<PlaygroundPage />} />
                </Routes>
            </Router>
        </div>
    )
}

export default App
